import axios from "../utils/axios";
import { BasicQuerySearch, defaultQuery, QueryResponse } from "./utilts";

export function fetchFAR(body: BasicQuerySearch & {
    property__id?: string;
    type?: string;
} = {}, token: string) {
    return new Promise<QueryResponse<any>>((resolve, reject) => {
        axios
            .get(`${process.env.REACT_APP_API_DOMAIN}/full-accessibility-report/`,
                {
                    headers: { 'Authorization': 'Token ' + token },
                    params: body
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}